import { FormGroup } from 'utils/form';

export default {
  include() {
    return {
      businessRuleGroup: new FormGroup({
        id: {},
        institutionId: { required: true },
        campusId: { greaterThan: 0 },
        courseId: { greaterThan: 0 },
        levelId: { greaterThan: 0 },
        kindId: { greaterThan: 0 },
        shiftId: { greaterThan: 0 },
        enrollmentSemester: { regex: /^\d{4}\.\d{1,2}$/ },
        origin: {},
        priority: { greaterThan: 0, required: true },
      }),
      splitRule: new FormGroup({
        recipientId: { required: true, greaterThan: 0 },
        percentage: { required: true, greaterThan: 0, lowerThan: 101 },
      }),
      queropagoSplitRule: new FormGroup({
        recipientId: { required: true, greaterThan: 0 },
        percentage: { required: true, greaterThan: 0, lowerThan: 101 },
      }),
      dueDayRule: new FormGroup({
        dueDays: { required: true, regex: /^\d+(,\s?\d+)*$/ },
        studentCanChangeDueDay: { required: true },
      }),
      paymentMethodRules: new FormGroup({
        methods: { required: true, value: [] },
      }),
      contractDischargeRules: new FormGroup({
        methods: {
          value: [],
          ignoredOnGetRawValueIfMatch: [{ methods: { values: [null, undefined, ''] } }],
        },
      }),
      contractCreationRule: new FormGroup({
        startRule: {
          ignoredOnGetRawValueIfMatch: [{ startRule: { values: [null, undefined, ''] } }],
        },
        duration: {
          ignoredOnGetRawValueIfMatch: [{ startRule: { values: [null, undefined, ''] } }],
          requiredIfMatch: { startRule: { values: [null, undefined, ''], condition: '!' } },
        },
      }),
      chargesRule: new FormGroup({
        type: { value: 'default', ignoreOnGetRawValue: true },
        applyCharges: {
          required: true,
          ignoredOnGetRawValueIfMatch: [{ type: { values: ['default'] } }],
        },
        interestRate: {
          greaterThanOrEqualTo: 0,
          lowerThanOrEqualTo: 1,
          ignoredOnGetRawValueIfMatch: [{ type: { values: ['default', 'disabled'] } }],
          requiredIfMatch: { type: { values: ['disabled'], condition: '!' } },
        },
        penaltyRate: {
          greaterThanOrEqualTo: 0,
          lowerThanOrEqualTo: 2,
          ignoredOnGetRawValueIfMatch: [{ type: { values: ['default', 'disabled'] } }],
          requiredIfMatch: { type: { values: ['disabled'], condition: '!' } },
        },
        chargesBasedOn: {
          ignoredOnGetRawValueIfMatch: [{ type: { values: ['default'] } }],
          requiredIfMatch: { type: { values: ['disabled'], condition: '!' } },
        },
      }),
      qbIntegrationRule: new FormGroup({
        integrationDisallowed: {
          required: true,
          value: false,
          ignoredOnGetRawValueIfMatch: [{ integrationDisallowed: { values: [false] } }],
        },
      }),
      admissionPaymentRule: new FormGroup({
        enabled: { required: true, value: 'false', ignoreOnGetRawValue: true },
        amountType: {
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: ['false'] } }],
          requiredIfMatch: { enabled: { values: ['true'] } },
        },
        amount: {
          greaterThan: 0,
          ignoredOnGetRawValueIfMatch: [
            { enabled: { values: ['false'] } },
            { amountType: { values: ['custom_amount'], condition: '!' }, condition: '||' },
          ],
          requiredIfMatch: { amountType: { values: ['custom_amount'] } },
        },
        percentage: {
          greaterThan: 0,
          lowerThanOrEqualTo: 100,
          ignoredOnGetRawValueIfMatch: [
            { enabled: { values: ['false'] } },
            {
              amountType: {
                values: ['percentage_of_amount_with_discount', 'percentage_of_amount_without_discount'],
                condition: '!',
              },
              condition: '||',
            },
          ],
          requiredIfMatch: {
            amountType: { values: ['percentage_of_amount_with_discount', 'percentage_of_amount_without_discount'] },
          },
        },
        equivalentToFirstBill: {
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: ['false'] } }],
          requiredIfMatch: { enabled: { values: ['true'] } },
        },
      }),
      underpaymentRule: new FormGroup({
        enabled: { required: true, value: false, ignoreOnGetRawValue: true },
        adjustmentType: {
          value: 'underpayment',
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
        thresholdType: {
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
        thresholdValue: {
          greaterThan: 0,
          lowerThanOrEqualTo: 100,
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
      }),
      overpaymentRule: new FormGroup({
        enabled: { required: true, value: false, ignoreOnGetRawValue: true },
        adjustmentType: {
          value: 'overpayment',
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
        thresholdType: {
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
        thresholdValue: {
          greaterThan: 0,
          lowerThanOrEqualTo: 100,
          requiredIfMatch: { enabled: { values: [true] } },
          ignoredOnGetRawValueIfMatch: [{ enabled: { values: [false] } }],
        },
      }),
      advancedPaymentDiscountRules: {
        create: [],
        disable: [],
      },
    };
  },
};
